import React, { useRef } from 'react';
import { Button, Progress, List } from 'antd';
import { UploadOutlined, DeleteOutlined } from '@ant-design/icons';
import type { CategoriaArquivo, ArquivoFormulario } from '@engenharia/shared';

interface FileUploadFieldProps {
  label: string;
  categoria: CategoriaArquivo;
  arquivos: ArquivoFormulario[];
  uploading: boolean;
  progress: number;
  required?: boolean;
  multiple?: boolean;
  onUpload: (categoria: CategoriaArquivo, file: File) => void;
  onDelete: (id: number) => void;
}

export default function FileUploadField({
  label, categoria, arquivos, uploading, progress, required, multiple, onUpload, onDelete
}: FileUploadFieldProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  const filtered = arquivos.filter((a) => a.categoria === categoria);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (!files) return;
    for (const file of Array.from(files)) {
      onUpload(categoria, file);
    }
    e.target.value = '';
  };

  return (
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <input
        ref={inputRef}
        type="file"
        className="hidden"
        multiple={multiple}
        accept="image/*,.pdf"
        onChange={handleChange}
      />
      <Button
        icon={<UploadOutlined />}
        onClick={() => inputRef.current?.click()}
        loading={uploading}
        size="small"
      >
        Enviar arquivo
      </Button>
      {uploading && <Progress percent={progress} size="small" className="mt-1" />}
      {filtered.length > 0 && (
        <List
          size="small"
          className="mt-2"
          dataSource={filtered}
          renderItem={(item) => (
            <List.Item
              actions={[
                <Button
                  key="del"
                  type="text"
                  danger
                  size="small"
                  icon={<DeleteOutlined />}
                  onClick={() => item.id && onDelete(item.id)}
                />,
              ]}
            >
              {item.nome_original || item.storage_key}
            </List.Item>
          )}
        />
      )}
    </div>
  );
}
